module.exports = __webpack_public_path__ + "img/prestashop_1.5fd5e42e.png";